import { get } from '@/services/Axios';
import debounce from 'lodash.debounce';
import errorHandler from '@/mixins/errorHandler';

export default {
  mixins: [errorHandler],
  data() {
    return {
      groupOptions: [],
      groups: [],
      loadGroupOptions: false,
      loadGroups: false,
      paginationGroups: {},
      formGroupOptionsName: '',
      searchGroupsOptions: ''
    };
  },
  watch: {
    searchGroupsOptions(val) {
      if (
        this[this.formGroupOptionsName] &&
        (!this[this.formGroupOptionsName].group ||
          val !== this[this.formGroupOptionsName].group.accountGroupName)
      ) {
        this.getGroupOptions({ keyword: val });
      }
    }
  },
  methods: {
    getGroupOptions: debounce(async function(...param) {
      this.loadGroupOptions = true;
      const parameter = param[0] || {};
      const params = {
        sort: 'account_group_name',
        dir: 'ASC',
        filter: [
          {
            type: 'string',
            field: 'account_group_name',
            value: parameter.keyword || '',
            comparison: '<>'
          }
        ]
      };
      if (parameter.filters) {
        this.params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results }
        } = await get('/group/list-option', { params });
        this.groupOptions = results;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadGroupOptions = false;
      }
    }, 500),
    async getGroups(...param) {
      this.loadGroups = true;
      const parameter = param[0] || {};
      const params = {
        limit: parameter.limit || 10,
        page: parameter.page || 1,
        sort: parameter.sorts || 'account_group_name',
        dir: parameter.dir || 'ASC',
        filter: []
      };
      if (parameter.filter) {
        this.params.filter.push(...parameter.filter);
      }
      try {
        const {
          data: { results, pagination }
        } = await get('/master/group/list', { params });
        this.groups = results;
        this.paginationGroups = pagination;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadGroups = false;
      }
    }
  }
};
